class GraphDataList {
    constructor({
        month=0,
        label="",
        value=0,
        users_per_month=0
    }) {
        this.month = month;
        this.label = label;
        this.value = value;
        this.users_per_month = users_per_month;
    }
}

class GraphModel {
    constructor({
        projectsByMonth = [],
        totalUsers = 0,
        totalProjectCount = 1,
        completedProjectCount = 0,
        notStartedProjectCount = 0,
        onGoingProjectCount = 0
    }) {
        this.projectsByMonth = projectsByMonth.map(project => new GraphDataList(project));
        this.totalUsers = totalUsers;
        this.totalProjectCount = totalProjectCount;
        this.completedProjectCount = completedProjectCount;
        this.notStartedProjectCount = notStartedProjectCount;
        this.onGoingProjectCount = onGoingProjectCount;
    }
}

export { GraphDataList, GraphModel };
